import { render, staticRenderFns } from "./VendorsReviewChart.vue?vue&type=template&id=2d108be2"
import script from "./VendorsReviewChart.vue?vue&type=script&lang=js"
export * from "./VendorsReviewChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports